import * as React from 'react';
import { useLink } from '@grandvisionhq/frk-routing';
import { useFeatureToggles, useDispatch } from '@grandvisionhq/state';
import { useGetFrame } from '../hooks/use-get-frame.js';
import { usePrescriptionTypes } from '../hooks/use-prescription-types.js';
import { startPrescriptionGlassesConfiguration } from '../state/actions.js';
import { convertCmsRxEntries } from '../utils/convert-cms-rx-entries.js';

const RxGlassesConfiguratorContext = /*#__PURE__*/ React.createContext({});
const useRxGlassesConfiguratorContext = ()=>React.useContext(RxGlassesConfiguratorContext)
;
const RxGlassesConfiguratorProvider = ({ children , opticianForm , configuratorDocument , frame: existingFrame , frameSlug , frameSku , id ,  })=>{
    const bookAppointmentLink = useLink({
        route: 'appointments.book'
    });
    const bookAppointmentRoute = bookAppointmentLink === null || bookAppointmentLink === void 0 ? void 0 : bookAppointmentLink.href;
    const frame = useGetFrame({
        existingFrame,
        frameSlug
    });
    const { isPrescriptionGlassesConfiguratorValidationStepEnabled: isExtraValidationStepEnabled  } = useFeatureToggles();
    const prescriptionTypesOrder = usePrescriptionTypes();
    let preselectedPrescriptionEntry = prescriptionTypesOrder === null || prescriptionTypesOrder === void 0 ? void 0 : prescriptionTypesOrder[0];
    const { entryTypes  } = (configuratorDocument === null || configuratorDocument === void 0 ? void 0 : configuratorDocument.prescriptionStep) || {};
    const rxEntryTypes = convertCmsRxEntries(entryTypes);
    if (rxEntryTypes === null || rxEntryTypes === void 0 ? void 0 : rxEntryTypes[0]) {
        preselectedPrescriptionEntry = rxEntryTypes[0].key;
    }
    const value = {
        opticianForm,
        configuratorDocument,
        isExtraValidationStepEnabled,
        id
    };
    const dispatch = useDispatch();
    React.useEffect(()=>{
        if (!frame) {
            return;
        }
        dispatch(startPrescriptionGlassesConfiguration({
            frame,
            frameSku,
            isExtraValidationStepEnabled,
            preselectedPrescriptionEntry,
            rxEntryTypes,
            bookAppointmentRoute
        }));
    }, [
        dispatch,
        frame
    ]);
    return /*#__PURE__*/ React.createElement(RxGlassesConfiguratorContext.Provider, {
        value: value
    }, children);
};

export { RxGlassesConfiguratorContext, RxGlassesConfiguratorProvider, useRxGlassesConfiguratorContext };
//# sourceMappingURL=RxGlassesConfiguratorContext.js.map
